var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useRef } from 'react';
import { VariableSizeList } from 'react-window';
import ReactResizeDetector from 'react-resize-detector';
var DEFAULT_VIRTUAL_COLLECTION_LIST_HEIGHT = 400;
var DEFAULT_VIRTUAL_COLLECTION_ROW_HEIGHT = 84;
export var useVirtualizedCollectionList = function (virtualizeFromCount, collectionList, renderListElement) {
    var virtualListRef = useRef(null);
    // Forget all row heights cached by react-window virtualized list if collection changes
    useEffect(function () {
        var _a;
        (_a = virtualListRef === null || virtualListRef === void 0 ? void 0 : virtualListRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(0);
    }, [collectionList]);
    // Store all row heights in a map which will be read by react-window virtualized list
    var rowSizeMap = useRef({});
    var getRowSize = useCallback(function (index) {
        return rowSizeMap.current[index] || DEFAULT_VIRTUAL_COLLECTION_ROW_HEIGHT;
    }, []);
    var setRowSize = useCallback(function (index, size) {
        var _a;
        var _b;
        rowSizeMap.current = __assign(__assign({}, rowSizeMap.current), (_a = {}, _a[index] = size, _a));
        (_b = virtualListRef === null || virtualListRef === void 0 ? void 0 : virtualListRef.current) === null || _b === void 0 ? void 0 : _b.resetAfterIndex(index);
    }, []);
    // Use ReactResizeDetector to update map of row heights when some row height changes
    var onRowResize = useCallback(function (index, width, height) {
        setRowSize(index, height);
    }, [setRowSize]);
    // Virtual List row render method must be stable (ie. not defined inline), or else row will be re-created and lose focus on every input
    var virtualListRowRender = useCallback(function (_a) {
        var index = _a.index, style = _a.style, data = _a.data;
        return (React.createElement("div", { style: style },
            React.createElement(ReactResizeDetector, { handleWidth: false, handleHeight: true, onResize: function (width, height) { return onRowResize(index, width, height); } }, renderListElement(index, data))));
    }, [onRowResize, renderListElement]);
    if (virtualizeFromCount === undefined || collectionList.length < virtualizeFromCount) {
        return collectionList.map(function (v, index) { return renderListElement(index, collectionList); });
    }
    else {
        return (React.createElement(VariableSizeList, { className: 'collectionField__virtualizedListContainer', style: { overflow: undefined }, ref: virtualListRef, itemData: collectionList, itemSize: getRowSize, itemCount: collectionList.length, height: DEFAULT_VIRTUAL_COLLECTION_LIST_HEIGHT, estimatedItemSize: DEFAULT_VIRTUAL_COLLECTION_ROW_HEIGHT, width: 'auto' }, virtualListRowRender));
    }
};
//# sourceMappingURL=useVirtualizedCollectionList.js.map